/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, arrayOf, bool, number,
    string, func, objectOf, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../../../common/Form';
import { form as formStyle } from '../../../style/form';
import ErrorInline from '../../../common/ErrorMessages/ErrorInline';
import EventDispatcher from '../../../state/reducers/EventDispatcher';

const styles = ({ typography, palette }) => formStyle(typography, palette);

class DesktopSelectAddressDropdown extends Form {
    state = { data: { addressbook: '0' }, errors: {}, inlineError: '' };

    schema = {
        addressbook: Joi.string()
            .alphanum()
            .required()
            .label('Address Book'),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { recipients, fetchAddressBook } = this.props;
        fetchAddressBook(recipients);
    };

    doSubmit = (submitData) => {
        const { data } = this.state;
        // console.log('doSumbit', data, eventInterface);
        // if (!data.addressbook === '0') return;
        if (data.addressbook === '0') {
            const inlineError = 'Error adding recipient to the gift list.';
            this.setState({ inlineError });
            return;
        }
        /* istanbul ignore next */
        if (typeof submitData === 'undefined') return;

        const {
            addressBooks,
            giftListRecipients,
            occasionId,
            // eslint-disable-next-line no-unused-vars
            handleSubmitAddNewRecipient,
        } = submitData;

        const index = addressBooks.findIndex((item) => item.id.toString() === data.addressbook);
        if (index < 0) {
            const inlineError = 'There is something wrong with selected address.';
            this.setState({ inlineError });
            return;
        }
        const {
            FirstName, LastName, EmployerName, NickName = '',
            RelationShip = '0', PhoneNumber = '', Addresses = [],
        } = addressBooks[index];
        const {
            AddressType, AddressLineOne, AddressLineTwo,
            City, StateProvince, PostalCode, Country,
        } = Addresses[0];

        // Check if this recipient was already added to the gift list
        const recipientFound = giftListRecipients[occasionId].filter((item) => item.firstname.toUpperCase() === FirstName.toUpperCase()
                && item.lastname.toUpperCase() === LastName.toUpperCase()
                && item.address.street.toUpperCase() === AddressLineOne.toUpperCase()
                && item.address.apt.toUpperCase() === AddressLineTwo.toUpperCase()
                && item.address.city.toUpperCase() === City.toUpperCase()
                && item.address.country.id.toUpperCase() === Country.toUpperCase()
                && item.address.location.name.toUpperCase() === AddressType.toUpperCase()
                && item.address.state.id.toUpperCase() === StateProvince.toUpperCase()
                && item.address.zipcode.replace(/-\d{4}$/, '') === PostalCode.replace(/-\d{4}$/, ''));
        if (recipientFound && recipientFound.length) {
            const errors = {
                addressbook: `${FirstName} ${LastName} has been added to the gift list.`,
            };
            this.setState({ errors });
            return;
        }
        const recipientData = {
            addressEntry: {
                FirstName,
                LastName,
                EmployerName,
                NickName,
                RelationShip,
                PhoneNumber,
            },
            address: {
                AddressType,
                AddressLineOne,
                AddressLineTwo,
                City,
                StateProvince,
                PostalCode,
                Country,
                IsBillingAddress: false,
            },
        };
        handleSubmitAddNewRecipient(
            recipientData,
            '',
            '',
            'GiftListRecipientForm',
            occasionId,
            '',
            1,
            {},
        );
    };

    doChange = () => {
        this.setState({ inlineError: '' });
    };

    render() {
        const {
            classes,
            isReadyState,
            occasionId,
            recipients,
            giftListRecipients,
            onChange,
            handleSubmitAddNewRecipient,
        } = this.props;
        const { inlineError } = this.state;

        /* istanbul ignore next */
        if (!recipients) return null;

        const { data } = this.state;
        const addressBooks = [
            {
                id: 0,
                name: 'Select From Address Book',
                FirstName: '',
                LastName: '',
                NickName: '',
                EmployerName: '',
                Addresses: [],
                RelationShip: 0,
            },
        ];

        recipients.forEach((r) => {
            addressBooks.push({
                id: r.AddressBookEntryId,
                name: `${r.FirstName} ${r.LastName}`,
                FirstName: r.FirstName,
                LastName: r.LastName,
                NickName: r.NickName,
                EmployerName: r.EmployerName,
                Addresses: r.Addresses,
                RelationShip: r.RelationShip,
            });
        });

        const submitData = {
            addressBooks,
            occasionId,
            giftListRecipients,
            handleSubmitAddNewRecipient,
        };

        return (
            <>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={classes.form}
                >
                    <ErrorInline
                        error={inlineError}
                        customClass="margin-top"
                        isReadyState={isReadyState}
                    />

                    {this.renderSelect({
                        name: 'addressbook',
                        label: '',
                        options: addressBooks,
                        onChangeHandler: onChange,
                    })}

                    <div
                        className={
                            data.addressbook !== '0'
                                ? 'margin-top-2x'
                                : 'display-none'
                        }
                    >
                        {this.renderButton({
                            label: 'Add Recipient',
                            className: 'no-margin',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>
                </form>
            </>
        );
    }
}

DesktopSelectAddressDropdown.defaultProps = {
    recipients: [],
    addressBooks: [],
    onChange: () => {},
    handleSubmitAddNewRecipient: () => {},
    fetchAddressBook: () => {},
};

DesktopSelectAddressDropdown.propTypes = {
    classes: object.isRequired,
    isReadyState: bool.isRequired,
    occasionId: string.isRequired,
    giftListRecipients: objectOf(
        arrayOf(
            shape({
                AddressBookEntryId: string,
                addToCart: string,
                address: shape({
                    addressId: string,
                    apt: string,
                    city: string,
                    company: string,
                    country: shape({
                        id: string,
                        name: string,
                    }),
                    location: shape({
                        id: number,
                        name: string,
                    }),
                    state: shape({
                        id: string,
                        name: string,
                    }),
                    street: string,
                    zipcode: string,
                }),
                addressId: string,
                cartDetail: object,
                error: object,
                firstname: string,
                giftArrived: string,
                id: string,
                isNewRecipient: bool,
                lastname: string,
                occasionId: string,
                orderItemId: string,
                products: arrayOf(
                    shape({
                        content: string,
                        crossedPrice: string,
                        discountPrice: string,
                        id: string,
                        image: string,
                        name: string,
                        parentCatalogEntryId: string,
                        partNumber: string,
                        price: number,
                        seoproductDisplayURL: string,
                        sku: string,
                        status: string,
                    }),
                ),
            }),
        ),
    ),
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            Addresses: arrayOf(
                shape({
                    AddressBookEntryId: string,
                    AddressId: number,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    AddressType: string,
                    City: string,
                    ContactId: number,
                    Country: string,
                    IsBillingAddress: bool,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    PostalCode: string,
                    StateProvince: string,
                }),
            ),
            ContactId: number,
            EmployerName: string,
            FirstName: string,
            LastName: string,
            LastUpdateDate: string,
            NickName: string,
            NumberOfAddresses: number,
            RelationShip: string,
        }),
    ),
    onChange: func,
    handleSubmitAddNewRecipient: func,
    fetchAddressBook: func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state.account ? state.account : state;
    return {
        isReadyState: newState.isReadyState,
        occasionId: newState.giftList.occasionId,
        recipients: newState.recipients,
        giftListRecipients: newState.giftList.recipients,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitAddNewRecipient: (data, AddressId, AddressBookEntryId, templateName, occasionId, orderItemId, currentPage, recipient) => dispatch(EventDispatcher.handleSubmitAddNewRecipient(
        data,
        AddressId,
        AddressBookEntryId,
        templateName,
        occasionId,
        orderItemId,
        currentPage,
        recipient,
    )),
    fetchAddressBook: (recipients) => dispatch(EventDispatcher.fetchAddressBook(recipients)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(DesktopSelectAddressDropdown));
